import React, { PropsWithChildren, ReactNode } from 'react'

import { ReactComponent as InfoIcon } from '@app/assets/Small/Filled/Info.svg'
import { bemJoin } from '@app/lib/bem'

import './styles.scss'

type InfoTooltipProps = {
  message: ReactNode
}

export const InfoTooltip = ({ message, children }: PropsWithChildren<InfoTooltipProps>) => {
  const b = bemJoin('info-tooltip')

  return (
    <div className={b()}>
      <div className={b('children')}>{children}</div>
      <div className={b('info-wrapper')}>
        <div className={b('tip')}>{message}</div>
        <div className={b('info')} aria-label={'info'}>
          <InfoIcon />
        </div>
      </div>
    </div>
  )
}
